export type UploadProgressState = {
  percent: number;
  phase: 'uploading' | 'finalizing' | 'completed' | 'error';
};

// File identities survive form rerenders; weak keys do not retain large files.
const progress = new WeakMap<Blob, UploadProgressState>();
const listeners = new Set<() => void>();

export function getFileUploadProgress(file: unknown): UploadProgressState | null {
  return typeof Blob !== 'undefined' && file instanceof Blob ? progress.get(file) ?? null : null;
}

export function subscribeUploadProgress(listener: () => void) {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

export function setFileUploadProgress(file: unknown, percent: number, phase: UploadProgressState['phase']) {
  if (typeof Blob === 'undefined' || !(file instanceof Blob)) return;
  const normalized = Math.max(0, Math.min(phase === 'completed' ? 100 : 99, Math.floor(percent)));
  const previous = progress.get(file);
  if (previous?.percent === normalized && previous.phase === phase) return;
  progress.set(file, { percent: normalized, phase });
  listeners.forEach(listener => listener());
}
